document.addEventListener('DOMContentLoaded', function () {
  // Get elements
  const technologySec = document.querySelector('.technology-sec');
  const backtop = $('.backtop');  // using jQuery

  // Function to toggle the backtop visibility
  const toggleBacktopVisibility = () => {
    const rect = technologySec.getBoundingClientRect();

    if (rect.top < 0) {
      backtop.fadeIn();
    } else {
      backtop.fadeOut();
    }
  };

  // Initial check in case the user has already scrolled
  toggleBacktopVisibility();

  // Listen for scroll events
  window.addEventListener('scroll', toggleBacktopVisibility);
});
